import { Slide } from 'sharebase-app/domain';
require('./slidesView.styles');
const baseTemplate = require('./slidesView.template');
/**
 * Service for showing a group of slides in dialog.
 */

/**
 * @ngdoc directive
 * @name sbaSlidesView
 * @module sharebase-app.slidesView
 * @restrict E
 * @description
 * 
 * A directive displaying various number of slides.
 */
export function SlidesViewDirective():ng.IDirective {
    return {
        restrict: 'E',
        scope: false,
        template: baseTemplate,
        transclude: true
    };
};

interface SlideDirectiveInheritedScope extends ng.IScope {
    vm:SlidesViewController<Slide>;
}

/**
 * @ngdoc directive
 * @name sbaSlide
 * @module sharebase-app.slidesView
 * @restrict E
 * @description
 * 
 * A directive to display a single slide in a slidesView.
 */
export function SlideDirective():ng.IDirective {
    return {
        restrict: 'E',
        require: '^^sbaSlidesView',
        scope: false
    }
};

const INTERVAL:number = 5000;
export abstract class SlidesViewController<T extends Slide> implements ng.IController{
    public static $inject = [
        '$mdPanel',
        '$mdMedia',
        '$timeout',
        '$interval'
    ];

    public activeSlide:number = 0;
    public get slideCount() {
        return this._activeSlides.length;
    }
    public get activeSlides(){
        return this._activeSlides;
    }
    public get currentSlide(){
        return this.activeSlides[this.activeSlide];
    }
    public readonly slides:T[] = [];
    public autoRotate:boolean = false;
    public allowSkipping:boolean;
    public showNavButtons:boolean;
    private timer;
    private mdPanelRef:ng.material.IPanelRef;
    private _activeSlides:T[] = [];

    constructor(
        private readonly $mdPanel:ng.material.IPanelService,
        private readonly $mdMedia,
        public readonly $timeout:ng.ITimeoutService,
        private readonly $interval:ng.IIntervalService,
        private readonly template:string
    ) {
    }

    public show(){
        this._activeSlides = this.slides.filter(s => s.visible);
        let panelPosition = this.$mdPanel.newPanelPosition()
            .absolute()
            .center();
        let panelAnimation = this.$mdPanel.newPanelAnimation()
            .openFrom({
                top:  this.$mdMedia('xs') ? document.documentElement.clientHeight : 0,
                left: 0
            })
            .withAnimation(this.$mdMedia('xs') ? this.$mdPanel.animation.SLIDE : this.$mdPanel.animation.FADE)
            .closeTo({
                top: this.$mdMedia('xs') ? document.documentElement.clientHeight : 0,
                left: 0
            });
        let config = {
            attachTo: angular.element(document.body),
            position: panelPosition,
            animation: panelAnimation,
            template: this.template,
            controller: () => this,
            controllerAs: 'vm',
            bindToController: true,
            panelClass: 'sba-slides-dialog md-whiteframe-6dp app--selction-disabled',
            clickOutsideToClose: false,
            escapeToClose: true,
            focusOnOpen: true,
            hasBackdrop: true,
            fullscreen: this.$mdMedia('xs')
        };

        this.mdPanelRef = this.$mdPanel.create(config);
        this.mdPanelRef.open().then(angular.noop);
    }
    
    public close(){
        if(this.mdPanelRef){
            this.mdPanelRef.close().then(() => {
                this.activeSlide = 0;
            });            
        }        
    }

    public beginTimer(){
        if(!this.autoRotate){ 
            return;
        }

        if(this.timer){
            this.$interval.cancel(this.timer);
        }

        this.timer = this.$interval(()=>{
            this.goForward();
        }, INTERVAL);
    };

    public setActiveSlide(index:number){
        this.activeSlide = index;
        this.beginTimer();
    }

    public goForward(){
        let nextSlideIndex = this.activeSlide + 1;
        this.setActiveSlide(nextSlideIndex < this.slideCount ? nextSlideIndex : 0);
    }

    public goBackward(){
        this.setActiveSlide(this.activeSlide > 0 ? (this.activeSlide - 1) : (this.slideCount - 1));
    }

    public swipeBackward(){
        if(this.allowSkipping){
            this.goBackward();
        }        
    }

    public swipeForward(){
        if(this.allowSkipping){
            this.goForward();
        }        
    }       
}


// WEBPACK FOOTER //
// ./src/sharebase-app/components/slides/slidesDialog/slidesDialog.ts